module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "printing-wrap"
  }, [_c('div', {
    staticClass: "printing"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "report-age-sex"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.name))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getPrintPageFirst.userSex == 1 ? '女' : '男')
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.userAge))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.createtime))])])]), _vm._v(" "), _c('div', {
    staticClass: "report-mumber"
  }, [_c('p', [_vm._v("报告单号："), _c('b', [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))])])])]), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "read-guid"
  }, [_c('p', [_vm._v("5-9岁是大脑发育的重要阶段，此阶段孩子正处于从前具体运算阶段（表象思维）到具体运算阶段（出现逻辑思维）的关键阶段，脑功能检测可以探讨动态脑功能网络。本报告将根据检测结果，对您孩子的脑功能进行精准分析，提供\n\t\t\t\t "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('span', [_vm._v("脑功能图谱的优劣势解读和")]) : _vm._e(), _vm._v(" 专业个性化提升方案，为孩子的脑效率和脑健康保驾护航。")])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h6', {
    staticClass: "sore-table-title"
  }, [_vm._v("表 得分与脑功能表现、人数占比对应表")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "read-table-bot"
  }, [_c('p', [_vm._v("最后，本报告包含了"), _c('span', [_vm._v(_vm._s(_vm.getPrintPageFirst.gameCount))]), _vm._v("个脑功能检测项目的结果，并根据孩子的结果提供"), (_vm.getPrintPageFirst.gameCount == 4) ? _c('span', [_vm._v("综合解读和")]) : _vm._e(), _vm._v("单项脑功能提升方案。\n\t\t\t\t"), (_vm.getPrintPageFirst.gameCount == 4) ? _c('span', [_vm._v("您可按照顺序先阅读综合脑功能结果与解读，再阅读各单项脑功能的提升方案。")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [_vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "score-Introduction"
  }, [_vm._v("\n\t\t\t\t本次检测包含" + _vm._s(_vm.getPrintPageFirst.gameNames) + "任务脑功能项目。"), (_vm.getPrintPageFirst.gameCount > 1) ? _c('span', [_vm._v("您孩子脑功能的综合得分为"), _c('span', [_vm._v(_vm._s(_vm.getPrintPageFirst.score))]), _vm._v("超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.getPrintPageFirst.agegroup) + _vm._s(_vm.getPrintPageFirst.exceed) + "%")]), _vm._v("的人，处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPageFirst.health))]), _vm._v("状态，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPageFirst.efficiency))]), _vm._v("水平。")]) : _vm._e(), _vm._v("以下是各项脑功能检测结果具体情况:\n\t\t\t")]), _vm._v(" "), _c('h6', {
    staticClass: "table-title"
  }, [_vm._v("\n\t\t\t\t表1 脑功能检测结果表\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "printing-table"
  }, [_c('table', [_vm._m(10), _vm._v(" "), _vm._l((_vm.getscoreList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.gameName))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.correctNum))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.correctRate) + "%")]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.exceed) + "%")]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainFunction))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainEfficiency))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainHealth))])])
  })], 2)]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', {
    staticClass: "coefficient-Interpretation"
  }, [_c('b', [_vm._v("脑功能解读:")]), _vm._l((_vm.brainVosList), function(item, index) {
    return _c('span', [_vm._v(_vm._s(item))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]), _vm._v(" "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('div', {
    staticClass: "printing"
  }, [_vm._m(13), _vm._v(" "), _c('p', {
    staticClass: "brain-bot"
  }, [_vm._v("\n\t\t\t\t根据对您孩子的数字比较任务、图形推理任务、数字倒背任务、瞬数圆点任务这四项任务表现的综合分析，您孩子的脑功能模式属于"), _c('span', [_vm._v(_vm._s(this.brainsuggest.brainType))]), _vm._v("。见图1:\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "echart-barin"
  }, [_c('div', {
    style: ({
      width: '400px',
      height: '400px'
    }),
    attrs: {
      "id": "radarChart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brain-img-bot"
  }, [_vm._v("\n\t\t\t\t图1 脑功能图谱\n\t\t\t")]), _vm._v(" "), _c('h6', {
    staticClass: "factor"
  }, [_vm._v("图谱解读")]), _vm._v(" "), _c('div', {
    staticClass: "map-inter"
  }, [_c('p', [_vm._v(_vm._s(_vm.brainsuggest.unscramble))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.reason))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPageFirst.gameCount !== 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle-three.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle-three-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.brainsuggest.advice))]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "childTitle-size",
    domProps: {
      "innerHTML": _vm._s(_vm.getshuzibijiao.brainCapacity)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.getshuzibijiao.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [(this.shuzibijiaoList.length <= 3) ? _c('table', _vm._l((_vm.shuzibijiaoList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e(), _vm._v(" "), (this.shuzibijiaoList.length > 3) ? _c('table', _vm._l((_vm.shuzibijiaoList1), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('a', {
    staticClass: "page-num carried5"
  })])]) : _vm._e(), _vm._v(" "), (this.shuzibijiaoList.length > 3 && _vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPageFirst.gameCount !== 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle-three.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle-three-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "childTitle-size",
    domProps: {
      "innerHTML": _vm._s(_vm.getshuzibijiao.brainCapacity)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.shuzibijiaoList2), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('a', {
    staticClass: "page-num carried5"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getluojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPageFirst.gameCount !== 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle-three.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle-three-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "childTitle-size",
    domProps: {
      "innerHTML": _vm._s(_vm.getluojituili.brainCapacity)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.getluojituili.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.luojituiliList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('a', {
    staticClass: "page-num carried5"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getgongzuojiyi.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPageFirst.gameCount !== 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle-three.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle-three-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "childTitle-size",
    domProps: {
      "innerHTML": _vm._s(_vm.getgongzuojiyi.brainCapacity)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.getgongzuojiyi.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.gongzuojiyiList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('a', {
    staticClass: "page-num carried5"
  })])]) : _vm._e(), _vm._v(" "), (_vm.zhuyiguangdu.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPageFirst.gameCount !== 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle-three.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.gameCount == 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle-three-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "childTitle-size",
    domProps: {
      "innerHTML": _vm._s(_vm.zhuyiguangdu.brainCapacity)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.zhuyiguangdu.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.zhuyiguangduList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('a', {
    staticClass: "page-num carried5"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPageFirst.gameCount == 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/postscript.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.gameCount !== 4) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/houji-two.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('a', {
    staticClass: "page-num postscript"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "closePrint",
    attrs: {
      "href": "javascript:;",
      "title": "打印"
    },
    on: {
      "click": function($event) {
        _vm.print_page()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "closePage",
    attrs: {
      "href": "javascript:;",
      "title": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.print_close()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "moveUp",
    attrs: {
      "href": "javascript:;",
      "title": "回到顶部"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-corver"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/report-logo.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-dete"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/report-size.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-naologo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/report-corver.png"),
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("姓名:")]), _vm._v(" "), _c('li', [_vm._v("性别:")]), _vm._v(" "), _c('li', [_vm._v("年龄:")]), _vm._v(" "), _c('li', [_vm._v("日期:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/read-guid.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/read-prin.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "read-prin"
  }, [_c('p', {
    staticClass: "read-prin-bot"
  }, [_vm._v("首先，检测结果受环境、大脑发育状态、个人状态影响。越安静的环境、发育越好的大脑、越良好的状态，检测结果和您孩子的实际情况越符合。值得注意的是，在5-9岁这一阶段，儿童大脑发育较快，且发育过程中不同脑功能发展的先后顺序存在个体差异，因此本报告中呈现的脑功能检测结果和分析，只是您孩子这一段时间内的状态，建议您从发展的角度看待孩子的脑功能状态，不要形成刻板印象。")]), _vm._v(" "), _c('p', [_vm._v("其次，99.9%用户在检测项目的得分介于0-100之间，得分越高表明您孩子的脑功能越好。得分与脑健康、脑效率对应关系，以及人数占比的对应关系见下表。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "read-table"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("得分")]), _vm._v(" "), _c('th', [_vm._v("脑健康")]), _vm._v(" "), _c('th', [_vm._v("脑效率")]), _vm._v(" "), _c('th', [_vm._v("人数占比")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[75~100"), _c('span', {
    staticClass: "numjia"
  }, [_vm._v("＋")])]), _vm._v(" "), _c('td', [_vm._v("健康")]), _vm._v(" "), _c('td', [_vm._v("出色")]), _vm._v(" "), _c('td', [_vm._v("6%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[60~75)")]), _vm._v(" "), _c('td', [_vm._v("健康")]), _vm._v(" "), _c('td', [_vm._v("良好")]), _vm._v(" "), _c('td', [_vm._v("24%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[25-60)")]), _vm._v(" "), _c('td', [_vm._v("亚健康")]), _vm._v(" "), _c('td', [_vm._v("中等")]), _vm._v(" "), _c('td', [_vm._v("64%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[0-25)")]), _vm._v(" "), _c('td', [_vm._v("不健康")]), _vm._v(" "), _c('td', [_vm._v("欠佳")]), _vm._v(" "), _c('td', [_vm._v("6%")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle-one.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("检测项目")]), _vm._v(" "), _c('th', [_vm._v("题目数")]), _vm._v(" "), _c('th', [_vm._v("正确数")]), _vm._v(" "), _c('th', [_vm._v("正确率")]), _vm._v(" "), _c('th', [_vm._v("反应时")]), _vm._v(" "), _c('th', [_vm._v("得分")]), _vm._v(" "), _c('th', [_vm._v("超过")]), _vm._v(" "), _c('th', [_vm._v("脑功能")]), _vm._v(" "), _c('th', [_vm._v("脑效率")]), _vm._v(" "), _c('th', [_vm._v("脑健康")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "coefficient-Interpretation"
  }, [_c('b', [_vm._v("系数解读:")]), _vm._v(" a. 反应时：用于反映个体信息加工时长，数字越小表明加工时间越短；b.红色字体表示您孩子的该项脑功能处于不健康状态，蓝色字体表示您孩子的该项脑功能处于亚健康状态。\n\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/childTitle-two.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Follow-up"
  }, [_c('p', [_vm._v("1、任一脑功能都是十分复杂的，无论多好的检测项目都无法完全评价孩子的脑功能，但科学检测是深入了解脑功能的一扇门。")]), _vm._v(" "), _c('p', [_vm._v("2、检测结果受环境和个人状态影响，越安静的环境、越良好的状态，都可能会使孩子的结果更真实。")]), _vm._v(" "), _c('p', [_vm._v("3、儿童和青少年时期处于脑功能发展的关键阶段，孩子的脑功能水平会随着年龄的增长而不断变化。因此，本次脑功能检测，只代表孩子现在所处年龄段的水平，建议您持续关注孩子的脑健康和脑效率。")]), _vm._v(" "), _c('p', [_vm._v("4、本检测主要用于评估孩子的基础脑功能，如果您想用于评价孩子的个人能力和学业能力发展，建议结合专业的人格、成就等测试。此外，越全面的脑功能检测，用于评价个人能力和学业能力发展的效度越高。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "QR-code"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/QR-code.jpg"),
      "alt": "六六脑官方微信"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "QR-we"
  }, [_vm._v("六六脑官方微信")]), _vm._v(" "), _c('p', {
    staticClass: "QR-we",
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("更多脑能力测评请登录"), _c('a', {
    attrs: {
      "target": "_Blank",
      "href": "http://cp.66nao.com"
    }
  }, [_vm._v("cp.66nao.com")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-968aa9e2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mechanismCard.vue
// module id = 767
// module chunks = 1